//* 지갑 API (코치)
// 2025.01.28
// 희문

import * as BaseApi from "api/Base.api";

export const getBalance = async () => {
    const url = `/koach/v2/wallet/balance`;
    return await BaseApi.get(url);
};
